import React from 'react';
import { getSafevaultSiteUrls } from '../../utils/safevaultSiteUrls';
import { footerHtml } from '../../utils/shellMarkup';

export default function Footer() {
 const urls=getSafevaultSiteUrls();
 return <footer className="sv-shell-footer" dangerouslySetInnerHTML={{__html:footerHtml(item=>item.href || urls[item.hrefKey])}} />;
}
